export default __webpack_public_path__ + "static/media/flag-brazil.8abb3271.svg";